export default "__VITE_ASSET__YSMAMhNz__"